export default
`<template>
  <DtMemberStack
    :members="members"
    canAdd
  />

  <MemberStack
    :members="moreMembers"
    canAdd
    canSearch
  />
</template>

<script>
  data () {
    return {
      members: [
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Kobe Bryant' },
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Killua Zoldyck' },
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Mikasa Ackermann' },
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Golden Brown' },
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Joe Harris' },
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Steve Joe' },
      ],
      moreMembers: [
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Kobe Bryant' },
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Killua Zoldyck' },
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Mikasa Ackermann' },
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Golden Brown' },
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Joe Harris' },
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Jane Foster' },
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Liz Smith' },
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Michael Roberts' },
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Loid Forger' },
        { img: 'https://www.uselooper.com/assets/images/avatars/uifaces12.jpg', name: 'Tanjiro Kamado' },
      ]
    }
  }
</script>`;